<template>
  <div>
    <NuxtLink to="/" class="site-logo" rel="home" aria-label="Ветси" v-analytics:header="{content: 'logo'}">
      <SvgoLogo style="" class="logo-icon" aria-hidden="true"/>
    </NuxtLink>
  </div>
</template>

<script setup>

</script>
